import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import BriocheLogo from './BriocheLogo';
import useDashboardStore from '../store/dashboardStore';

const { FiDownload, FiSave, FiSun, FiMoon } = FiIcons;

const HeaderBar = () => {
  const { monochrome, toggleMonochrome, dateFrom, dateTo, jumpToLatest } = useDashboardStore();

  return (
    <motion.header
      className="bg-brand-card border-b border-brand-muted2/20 px-6 py-4"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.16 }}
    >
      <div className="flex items-center justify-between max-w-7xl mx-auto">
        {/* Left: Logo & Title */}
        <div className="flex items-center space-x-4">
          <BriocheLogo className="w-10 h-10" />
          <div>
            <h1 className="text-xl font-semibold text-brand-fg">Brioche Sales Dashboard</h1>
            <p className="text-sm text-brand-muted">
              {dateFrom === dateTo ? dateFrom : `${dateFrom} → ${dateTo}`}
            </p>
          </div>
        </div>

        {/* Right: Actions */}
        <div className="flex items-center space-x-3">
          <motion.button
            onClick={jumpToLatest}
            className="px-4 py-2 bg-brand-muted2/20 hover:bg-brand-muted2/30 rounded-button text-sm text-brand-fg transition-colors"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            Jump to Latest
          </motion.button>

          <motion.button
            className="p-2 bg-brand-muted2/20 hover:bg-brand-muted2/30 rounded-button text-brand-fg transition-colors"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <SafeIcon icon={FiSave} className="w-4 h-4 text-brand-muted" />
          </motion.button>

          <motion.button
            onClick={toggleMonochrome}
            className="p-2 bg-brand-muted2/20 hover:bg-brand-muted2/30 rounded-button text-brand-fg transition-colors"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <SafeIcon icon={monochrome ? FiSun : FiMoon} className="w-4 h-4 text-brand-muted" />
          </motion.button>

          <motion.button
            className="p-2 bg-brand-accent hover:bg-brand-accent/80 rounded-button text-brand-bg transition-colors"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <SafeIcon icon={FiDownload} className="w-4 h-4" />
          </motion.button>
        </div>
      </div>
    </motion.header>
  );
};

export default HeaderBar;